import { useCallback, useEffect, useState } from 'react';
import { userService } from '../../services/user.service';
import { groupService } from '../../services/group.service';
import { UserProfile } from '../../types/user.types';

export interface ShellGroup {
  _id: string;
  name: string;
}

// Profile + the user's groups, used by the sidebar, mobile header and new-challenge picker.
// Layout stays mounted across routes, so refetch on navigation to pick up joined/created
// groups and Strava connect/disconnect without a full reload.
export const useAppShellData = (pathname: string) => {
  const [profile, setProfile] = useState<UserProfile | null>(null);
  const [myGroups, setMyGroups] = useState<ShellGroup[]>([]);

  const load = useCallback(async () => {
    const [profileRes, groupsRes] = await Promise.allSettled([userService.getCurrentUserProfile(), groupService.getGroups()]);
    if (profileRes.status === 'fulfilled') setProfile(profileRes.value.data);
    else console.error('Failed to load profile:', profileRes.reason);
    if (groupsRes.status === 'fulfilled') {
      const groups = (groupsRes.value.data?.myGroups ?? []) as ShellGroup[];
      setMyGroups(groups.map(g => ({ _id: g._id, name: g.name })));
    } else {
      console.error('Failed to load groups:', groupsRes.reason);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load, pathname]);

  return { profile, myGroups, reload: load };
};

export const displayNameOf = (profile: UserProfile | null): string => {
  if (!profile) return '';
  if (profile.displayName) return profile.displayName;
  const stravaName = [profile.stravaProfile?.firstname, profile.stravaProfile?.lastname].filter(Boolean).join(' ');
  return stravaName || profile.username;
};
